var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashSaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3332 4.99417C24.9198 4.99417 29.4485 9.52296 29.4485 15.1095C29.4485 20.696 24.9198 25.2248 19.3332 25.2248C13.7467 25.2248 9.2179 20.696 9.2179 15.1095C9.2179 9.52296 13.7467 4.99417 19.3332 4.99417",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5522 25.2248H27.1143",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 11.2562V9.97167",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 18.9631V20.2476",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.106 18.046C17.436 18.6093 18.0381 18.9577 18.691 18.9631H20.104C21.0292 18.9862 21.8208 18.3033 21.9337 17.3847C22.0466 16.4662 21.4439 15.6119 20.5407 15.4103L18.1336 14.8053C17.2409 14.5961 16.6485 13.7488 16.7585 12.8386C16.8685 11.9284 17.6457 11.2466 18.5626 11.2562H19.9755C20.6291 11.2607 21.2319 11.6092 21.5618 12.1734",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6718 19H30.2267C31.9456 19 33.3391 20.3935 33.3391 22.1124V29.8934C33.3391 31.6124 31.9456 33.0058 30.2267 33.0058H8.4398C6.72086 33.0058 5.32739 31.6124 5.32739 29.8934V22.1124C5.32739 20.3935 6.72086 19 8.4398 19H9.99463",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashSaving);
export default __webpack_public_path__ + "static/media/cash-saving.82202465e51150ec617fd0159d6176f8.svg";
export { ForwardRef as ReactComponent };